import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { AuthContext } from '../../../../contexts/AuthContext';
import { PermissionModulesEnum, PermissionActionsEnum } from "../../../../enums";
import { hasResourseAccess } from '../../../../utils/methods';
import Button from "../../../../components/Button";

interface HeaderProps {
  onAddNew: () => void;
}

const Header: React.FC<HeaderProps> = ({ onAddNew }) => {
  const { t } = useTranslation();
  const { isSystemAdmin, permissions } = useContext(AuthContext);

  const hasAddAccess = hasResourseAccess(isSystemAdmin, permissions, { accessibleTo: [{ [PermissionModulesEnum.Invoices]: [PermissionActionsEnum.Add] }] })

  return (
    <div className="row mb-6">
      <div className="col-6">
        <h4 className="m-0 fw-bold">{t('invoices.addList.pageTexts.header.title')}</h4>
        <p>{t('invoices.addList.pageTexts.header.subTitle')}</p>
      </div>
      <div className="col-6 d-flex align-items-center justify-content-end">
        {
          hasAddAccess && (
            <div className="add-new">
              <Button
                className="btn btn-primary waves-effect waves-light"
                onClick={onAddNew}
                text={t("invoices.addList.pageTexts.header.generateButton")}
              />
            </div>
          )
        }
      </div>
    </div>
  );
}

export default Header;